<template>
  <div class="lineBox">
    <p class="name" :style="{ ...props.nameStyle }">
      {{ props.data?.title || '-' }}
    </p>
    <p class="sub">{{ props.data?.sub1 || '-' }}</p>
    <p class="sub">{{ props.data?.sub2 || '-' }}</p>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => []
  },
  nameStyle: {
    type: Array,
    default: () => {}
  }
})
</script>

<style scoped lang="less">
.lineBox {
  background: #fff;
  height: auto;
  padding: 0 16px;
  margin-bottom: 16px;
  .name {
    color: rgba(60, 60, 60, 1);
    font-size: 16px;
    font-weight: 700;
  }
  .sub {
    color: rgba(110, 110, 110, 1);
    font-size: 12px;
  }
}
</style>
